import { Drawer } from "@mui/material";
import React from "react";

function CustomDrawer({ open, className, toggleDrawer, children }) {
  return (
    <div>
      <Drawer className={className} anchor="bottom" open={open} onClose={() => toggleDrawer?.()}>
        {children}
      </Drawer>
    </div>
  );
}

export default CustomDrawer;
